/**
 * Request browser geolocation for clock-in/out.
 * Resolves { latitude, longitude } or rejects with a clear Error.
 */
export function getBrowserLocation() {
	return new Promise((resolve, reject) => {
		if (!navigator.geolocation) {
			reject(
				new Error(
					'Location is not supported in this browser. Enable location access or ask a manager to allow clock-in without location.',
				),
			);
			return;
		}
		navigator.geolocation.getCurrentPosition(
			(position) => {
				resolve({
					latitude: Number(position.coords.latitude.toFixed(6)),
					longitude: Number(position.coords.longitude.toFixed(6)),
				});
			},
			(error) => {
				if (error?.code === 1) {
					reject(
						new Error(
							'Location permission denied. Allow location access or ask a manager to enable clock-in without location.',
						),
					);
					return;
				}
				if (error?.code === 3) {
					reject(new Error('Location request timed out. Try again.'));
					return;
				}
				reject(
					new Error(
						error?.message ||
							'Could not get your location. Try again.',
					),
				);
			},
			{ enableHighAccuracy: true, timeout: 15000, maximumAge: 0 },
		);
	});
}
